module.exports = __webpack_public_path__ + "img/UTFREM-12.c1d05ca8.jpg";